module.exports = __webpack_public_path__ + "static/media/redo-alt.daf1ab1f.svg";